// extracted by mini-css-extract-plugin
export default {"styleCenterAndFixed":"PHpMkV","button":"KrM2Ex"};